export default __webpack_public_path__ + "static/media/mockup.14d67915.svg";